const DEFAULT_TTL_MS = 5 * 60 * 1000;
const SHORT_TTL_MS = 2 * 60 * 1000;

export const CacheKeys = {
  mobileHomeGeneral: (lang) => `m_home_general_${lang}`,
  mobileHeaderGeneral: (lang) => `m_header_general_${lang}`,
  seoScripts: (lang) => `seo_scripts_${lang}`,
  megatogelData: () => "megatogel_data",
  idrProductionLink: () => "idr_production_link",
  latestWin: (currency) => `latest_win_${currency}`,
  freeSpinCount: (userId) => `free_spin_${userId}`,
};

export function getSessionCache(key) {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) return null;
    const { data, expiry } = JSON.parse(raw);
    if (Date.now() > expiry) {
      sessionStorage.removeItem(key);
      return null;
    }
    return data;
  } catch {
    return null;
  }
}

export function setSessionCache(key, data, ttlMs = DEFAULT_TTL_MS) {
  try {
    sessionStorage.setItem(
      key,
      JSON.stringify({ data, expiry: Date.now() + ttlMs })
    );
  } catch {
    // sessionStorage full or unavailable
  }
}

export function invalidateSessionCache(key) {
  try {
    sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export { DEFAULT_TTL_MS, SHORT_TTL_MS };
